import axios from 'axios';
import React, { useEffect, useState } from 'react';
import toast, { Toaster } from 'react-hot-toast';
import ReCAPTCHA from "react-google-recaptcha";
import classNames from 'classnames';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const CAPTCHA_KEY = process.env.REACT_APP_CAPTCHA_KEY;

const Career = () => {
    const [selectedCareer, setSelectedCareer] = useState(null);
    const [careersData, setCareersData] = useState([]);
    const [roles, setRoles] = useState([]);
    const [resumeFile, setResumeFile] = useState(null);
    const grecaptchaObject = window.grecaptcha;

    const [careerFormData, setCareerFormData] = useState({
        name: '',
        age: '',
        gender: '',
        email: '',
        mobile: '',
        department: '',
        qualification: '',
        isFresher: '',
        currentOrganisation: '',
        currentOrganisationFrom: '',
        currentOrganisationTo: '',
        currentDesignation: '',
        currentLocation: '',
        prevOrganisation: '',
        prevOrganisationFrom: '',
        prevOrganisationTo: '',
        prevDesignation: '',
        prevLocation: '',
        resume: null
    });
    const allowedFileType = ".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf";
    useEffect(() => {
        axios.get(`${API_BASE_URL}/careers`).then(response => {
            const careers = response.data;
            setRoles(careers.map(c => c.role));
            setCareersData(careers);
            setSelectedCareer(response.data[0]);
        })
    }, []);

    const onRoleChange = (e) => {
        setSelectedCareer(careersData.find(c => c.role === e.target.value))
    }

    const isValidEmail = (email) => {
        return /\S+@\S+\.\S+/.test(email);
    }

    const onCareerSubmit = (event) => {
        const { mobile, email, name, department, resume, isFresher } = careerFormData;
        console.log("isFresher -- ", isFresher);
        if (name === '') {
            toast.error("Enter a name to apply");
            event.preventDefault();
            return false;
        }

        if (mobile === '+91 ' && mobile.length !== 14) {
            toast.error("Enter a valid Mobile Number to apply");
            event.preventDefault();
            return false;
        }

        if (email === '' || !isValidEmail(email)) {
            toast.error("Enter a valid Email address to apply");
            event.preventDefault();
            return false;
        }

        if (department === '') {
            toast.error("Choose a Department of Interest to apply");
            event.preventDefault();
            return false;
        }

        if (isFresher === '') {
            toast.error("Select Fresher to proceed");
            event.preventDefault();
            return false;
        }

        if (resume === null) {
            toast.error("Uplod a resume to apply");
            event.preventDefault();
            return false;
        }

        if(isFresher === 'No') { 
            let {currentOrganisationTo, currentOrganisationFrom, prevOrganisationFrom, prevOrganisationTo } = careerFormData;
            if(currentOrganisationTo < currentOrganisationFrom) {
                toast.error("Current Organisation Year is invalid.");
                event.preventDefault();
                return false;
            }

            if(prevOrganisationFrom !== '' && prevOrganisationTo !== '') {
                if(prevOrganisationFrom < prevOrganisationTo) {
                    toast.error("Previous Organisation Year is invalid.");
                    event.preventDefault();
                    return false;
                }
            }
        }

        event.preventDefault();

        axios.post(`${API_BASE_URL}/careers/apply`, careerFormData).then((response => {
            toast.success('Application submitted successfully!')
        }));

        const fd = new FormData();
        fd.append("name", careerFormData.name);
        fd.append("department", careerFormData.department);
        fd.append("file", resumeFile);
        axios.post(`${API_BASE_URL}/careers/resume-upload`, fd).then((response => {
            //succesful resume upload
            document.getElementById("career-form").reset();
            setCareerFormData({
                name: '',
                age: '',
                gender: '',
                email: '',
                mobile: '',
                department: '',
                qualification: '',
                currentOrganisation: '',
                currentOrganisationFrom: '',
                currentOrganisationTo: '',
                currentDesignation: '',
                currentLocation: '',
                prevOrganisation: '',
                prevOrganisationFrom: '',
                prevOrganisationTo: '',
                prevDesignation: '',
                prevLocation: '',
                resume: null
            });
            setResumeFile(null);
        }));
    }

    const onCaptchaChange = (e) => {
    }

    const handleCareerFormDataChange = (e) => {
        let { name, value } = e.target;
     
        setCareerFormData({ ...careerFormData, [name]: value });
    }

    const handleResumeUpload = (e) => {
        const allowedFileTypesArr = allowedFileType.split(",")
        const fileUploaded = e.target.files[0];
        if (allowedFileTypesArr.indexOf(fileUploaded.type) === -1) {
            toast.error("Upload resume either in PDF format or Word document.");
            return;
        }
        setResumeFile(fileUploaded);
        setCareerFormData({ ...careerFormData, resume: fileUploaded });
        e.preventDefault();
    }
    return (
        <>
            <Toaster
                position="bottom-center"
                reverseOrder={false}
            />
            <div className='relative'>
                <div className="md:block hidden">
                    <img
                        className="object-cover w-screen home-img"
                        src="/assets/static/images/career-02.jpg"
                        alt=""
                    />
                </div>
                <div className="md:hidden block">
                    <img
                        className="object-cover w-screen banner-img"
                        src="/assets/static/images/career-02-sm.jpg"
                        alt=""
                    />
                </div>
            </div>

            <div id="career-openings" className='lg:scroll-m-32 scroll-m-16 flex flex-col justify-center text-center bg-white items-center h-full w-full py-4 lg:py-16'>
                <h2 className="text-dinshaw-theme">
                    Current Openings
                </h2>

                <div className='my-2 lg:my-8 flex flex-row w-full justify-center items-cemter'>
                    <select className="form-select lg:px-8 lg:py-4 py-3 px-2 text-xs lg:text-lg mt-2 lg:mt-6 dinshaw-fc-select-outline" placeholder='Department of Interest' onChange={onRoleChange}>
                        <option className='text-black' value="" disabled>Department of Interest</option>
                        {roles && roles.map(role => <option value={role}>{role}</option>)}
                    </select>
                </div>
            </div>
            {
                selectedCareer && (
                    <>
                        <div className='flex flex-col bg-dinshaw-career lg:justify-center lg:items-center'>
                            <p className='py-6 lg:py-16 px-6 lg:px-12 text-sm lg:text-base lg:w-3/4 w-full' >
                                <dl className='grid grid-cols-2 gap-1 lg:gap-4 lg:pl-24'>
                                    {
                                        selectedCareer.details.map((detail, index) => (
                                            <>
                                                <dt key={index} className='text-dinshaw-yellow font-bold'>{detail.key}:</dt>
                                                <dd className='text-white'>{detail.value}</dd>
                                            </>
                                        ))
                                    }
                                    <span className='text-dinshaw-yellow font-bold'>Key Responsibilities:</span>
                                    <ul className='list-disc  text-white hidden lg:block'>
                                        {
                                            selectedCareer.responsibilities.map((item, index) => <li key={index} class > {item}</li>)
                                        }
                                    </ul>
                                </dl>
                                <ul className='list-disc text-white lg:hidden '>
                                    {
                                        selectedCareer.responsibilities.map((item, index) => <li key={index} > {item}</li>)
                                    }
                                </ul>

                            </p>
                        </div>

                        <form onSubmit={onCareerSubmit} encType='multipart/form-data' id="career-form">
                            <div className='bg-dinshaw-green p-4 lg:p-16'>
                                <div className="mx-4 lg:mx-32">
                                    <h2 className='text-dinshaw-yellow mb-2 lg:mb-6'> Apply Now <span className='text-xs md:text-sm text-dinshaw-theme'> (Fields marked with Asterisk * are mandatory)</span></h2>

                                    <div className='grid grid-cols-1 lg:grid-cols-2 lg:gap-32'>
                                        <div className='flex flex-col'>
                                            <input
                                                type="text"
                                                name="name"
                                                required
                                                className="px-4 lg:px-8 py-3 mt-6 dinshaw-fc-text"
                                                placeholder="Name*"
                                                onChange={handleCareerFormDataChange}
                                            />

                                            <div className='mt-6 flex flex-row'>
                                                <input
                                                    type="number"
                                                    name="age"
                                                    required
                                                    min="18"
                                                    max="58"
                                                    maxLength={2}
                                                    className="px-4 lg:px-8 py-3 m-0 dinshaw-fc-text"
                                                    placeholder="Age*"
                                                    onChange={handleCareerFormDataChange}
                                                />
                                                <select className="form-select px-4 lg:px-8 py-3 ml-6 dinshaw-fc-select" placeholder='Gender' name="gender" required onChange={handleCareerFormDataChange}>
                                                    <option className='text-black' value="" disabled selected>Gender*</option>
                                                    <option value="Male">Male</option>
                                                    <option value="Female">Female</option>
                                                    <option value="Others">Others</option>
                                                </select>
                                            </div>

                                            <input
                                                type="email"
                                                name="email"
                                                required
                                                className="px-4 lg:px-8 py-3 mt-6 dinshaw-fc-text"
                                                placeholder="Email*"
                                                onChange={handleCareerFormDataChange}
                                            />
                                            <div class="input-box px-4 lg:px-8 py-3 mt-6">
                                                <span class="hidden focus-visible:block ">+91</span>
                                                <input
                                                    type="tel"
                                                    name='mobile'
                                                    title='Mobile Number'
                                                    required
                                                    maxLength={14}
                                                    className="dinshaw-fc-text"
                                                    placeholder="Mobile*"
                                                    onChange={(e) => {
                                                        let input = e.target.value;
                                                        if (input.length === 1) {
                                                            input = input.replace(/\D/g, "");
                                                            e.target.value = "+91 " + input;
                                                        } else {
                                                            input = input.substr(4).replace(/\D/g, "");
                                                            e.target.value = "+91 " + input
                                                        }
                                                        handleCareerFormDataChange(e);
                                                    }}
                                                //onChange={handleCareerFormDataChange}
                                                />
                                            </div>


                                            <select className="form-select px-4 lg:px-8 py-3 mt-6 dinshaw-fc-select" placeholder='Department of Interest' name='department' required onChange={handleCareerFormDataChange}>
                                                <option className='text-black' value="" disabled selected>Department of Interest*</option>
                                                {roles && roles.map(role => <option value={role}>{role}</option>)}
                                            </select>

                                            <input
                                                type="text"
                                                name='qualification'
                                                required
                                                className="px-4 lg:px-8 py-3 mt-6 dinshaw-fc-text"
                                                placeholder="Educational Qualification*"
                                                onChange={handleCareerFormDataChange}
                                            />
                                            <div className='grid grid-cols-2 text-sm lg:text-xl font-bold pl-4 lg:pl-8 items-center mt-6'>
                                                <label className='text-black'>Fresher * </label>
                                                <div className="w-full flex justify-start">
                                                    <div role="group">
                                                        <button
                                                            type="button"
                                                            onClick={() => handleCareerFormDataChange({ target: { name: 'isFresher', value: 'Yes' } })}
                                                            className=
                                                            {classNames('rounded-l-full px-6 py-2 border-2 border-dinshaw-theme  font-bold text-sm lg:text-xl lg:font-bold hover:bg-dinshaw-theme hover:text-white',
                                                                { 'bg-dinshaw-theme text-white': careerFormData.isFresher === "Yes", 'bg-slate-100 text-dinshaw-theme': careerFormData.isFresher === "No" || careerFormData.isFresher === "" })}


                                                        >
                                                            Yes
                                                        </button>
                                                        <button
                                                            type="button"
                                                            onClick={() => handleCareerFormDataChange({ target: { name: 'isFresher', value: 'No' } })}
                                                            className=
                                                            {classNames('rounded-r-full  px-6 py-2 border-r-2 border-t-2 border-b-2  border-dinshaw-theme  font-bold text-sm lg:text-xl lg:font-bold  hover:bg-dinshaw-theme hover:text-white',
                                                                { 'bg-dinshaw-theme text-white': careerFormData.isFresher === "No", 'bg-slate-100 text-dinshaw-theme': careerFormData.isFresher === "Yes" || careerFormData.isFresher === "" })}

                                                        >
                                                            No
                                                        </button>
                                                    </div>
                                                </div>

                                            </div>
                                            {
                                                careerFormData.isFresher === 'No' &&
                                                <>
                                                    <div className='mt-12'>


                                                        <input
                                                            type="text"
                                                            required
                                                            name='currentOrganisation'
                                                            className="px-4 lg:px-8 py-3 mt-6 dinshaw-fc-text"
                                                            placeholder="Current Organisation*"
                                                            onChange={handleCareerFormDataChange}
                                                        />
                                                        <div className='mt-6 flex flex-row'>
                                                            <input
                                                                type="number"
                                                                required
                                                                name="currentOrganisationFrom"
                                                                className="px-4 lg:px-8 py-3 m-0 dinshaw-fc-text"
                                                                placeholder="From*"
                                                                min="1970"
                                                                max={new Date().getFullYear()}
                                                                onChange={handleCareerFormDataChange}
                                                            />
                                                            <input
                                                                type="number"
                                                                required
                                                                name="currentOrganisationTo"
                                                                className="px-4 lg:px-8 py-3 ml-6 dinshaw-fc-text"
                                                                placeholder="To*"
                                                                min="1970"
                                                                max={new Date().getFullYear()}
                                                                onChange={handleCareerFormDataChange}
                                                            />
                                                        </div>

                                                        <div className='mt-6 flex flex-row'>
                                                            <input
                                                                type="text"
                                                                required
                                                                name='currentDesignation'
                                                                className="px-4 lg:px-8 py-3 dinshaw-fc-text"
                                                                placeholder="Designation*"
                                                                onChange={handleCareerFormDataChange}
                                                            />
                                                            <input
                                                                type="text"
                                                                required
                                                                name='currentLocation'
                                                                className="px-4 lg:px-8 py-3 ml-6 dinshaw-fc-text"
                                                                placeholder="Location*"
                                                                onChange={handleCareerFormDataChange}
                                                            />
                                                        </div>
                                                    </div>
                                                </>
                                            }
                                        </div>

                                        <div className='flex flex-col'>
                                            {
                                                careerFormData.isFresher === 'No' &&
                                                <>
                                                    <input
                                                        type="text"
                                                        name='prevOrganisation'
                                                        className="px-4 lg:px-8 py-3 mt-6 dinshaw-fc-text"
                                                        placeholder="Earlier Organisations"
                                                        onChange={handleCareerFormDataChange}
                                                    />
                                                    <div className='mt-6 flex flex-row'>
                                                        <input
                                                            type="number"
                                                            name='prevOrganisationFrom'
                                                            className="px-4 lg:px-8 py-3 m-0 dinshaw-fc-text"
                                                            placeholder="From"
                                                            min="1970"
                                                            max={new Date().getFullYear()}
                                                            onChange={handleCareerFormDataChange}
                                                        />
                                                        <input
                                                            type="number"
                                                            name='prevOrganisationTo'
                                                            className="px-4 lg:px-8 py-3 ml-6 dinshaw-fc-text"
                                                            placeholder="To"
                                                            min="1970"
                                                            max={new Date().getFullYear()}
                                                            onChange={handleCareerFormDataChange}
                                                        />
                                                    </div>
                                                    <div className='mt-6 mb-10 flex flex-row'>
                                                        <input
                                                            type="text"
                                                            name='prevDesignation'
                                                            className="px-4 lg:px-8 py-3 dinshaw-fc-text"
                                                            placeholder="Designation"
                                                            onChange={handleCareerFormDataChange}
                                                        />
                                                        <input
                                                            type="text"
                                                            name='prevLocation'
                                                            className="px-4 lg:px-8 py-3 ml-6 dinshaw-fc-text"
                                                            placeholder="Location"
                                                            onChange={handleCareerFormDataChange}
                                                        />
                                                    </div>
                                                </>
                                            }
                                            <div className='mt-2 flex flex-col items-start'>
                                                <div className="py-3 flex justify-center">
                                                    <ReCAPTCHA size='normal' sitekey={CAPTCHA_KEY} grecaptcha={grecaptchaObject} onChange={onCaptchaChange} />
                                                </div>
                                            </div>

                                            <div className='mt-2 lg:mt-2 flex justify-between items-end'>
                                                <div>
                                                    <a className='text-dinshaw-yellow text-sm lg:text-lg font-bold hover:underline' href="#">
                                                        <label className='cursor-pointer '>
                                                            Attach Resume with Picture
                                                            <input type='file' name='file' hidden
                                                                accept={allowedFileType}
                                                                onChange={args => handleResumeUpload(args)} />
                                                        </label></a>
                                                    {
                                                        resumeFile && <div className='truncate w-3/4 text-xs md:text-sm font-semibold text-dinshaw-theme' title={resumeFile.name} >[File] - {resumeFile.name}</div>
                                                    }
                                                </div>
                                                <button className="mt-2 py-3 px-10 lg:px-12 text-white rounded-full bg-dinshaw-theme text-base lg:text-xl">Submit</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </>
                )
            }

        </>
    )
}

export default Career;